module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Title":"Titel","Description":"Beschreibung","Keywords":"Keywords"}}')
  delete Component.options._Ctor
}
